import { WidgetProps } from '@rjsf/utils';
import { Grid } from '@mui/material';
import { useAppSelector } from '@/redux/hooks';
import { selectAudioLanguages } from '@/redux/selectors/constantsSelectors';
import Fieldset from '@/components/_common/Fieldset';
import LanguageSelector from '@/components/_common/LanguageSelector/LanguageSelector';
import AudioBox from '../AudioBox';

const AudioWidget = (props: WidgetProps) => {
  const { onChange, value } = props;
  const enumValues: string[] | undefined = props.schema?.items?.enum;
  const AudioLanguageVals = useAppSelector(selectAudioLanguages);
  const AudioLanguages = enumValues
    ? enumValues.map((val) => {
        const found = AudioLanguageVals?.find((lang) => lang.code.replace('_', '-') === val);
        return found ? { code: val, label: found.label, is_short_list: found.is_short_list } : { code: val, label: val, is_short_list: true };
      })
    : AudioLanguageVals;

  if (props.readonly) return <AudioBox value={value} />;

  return (
    <Grid container columnSpacing={5}>
      <Grid item sm={12}>
        <Fieldset label="Audio" color="secondary">
          <Grid container spacing={2} mt={0}>
            <Grid item sm={12}>
              <LanguageSelector color="secondary" languageCodes={value} languages={AudioLanguages} onChange={(codes) => onChange(codes)} />
            </Grid>
          </Grid>
        </Fieldset>
      </Grid>
    </Grid>
  );
};

export default AudioWidget;
